import styled from "@emotion/styled"

export const LabelSelect = styled.label`
  color: var(--chakra-colors-primary);
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  position: absolute;
  pointer-events: none;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  background: #fff;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
  font-family: "Inter";
`

export const ContentSelect = styled.div`
  position: relative;
  width: 100%;

  &.active-true {
    .select-label {
      top: 0;
      font-size: 12px;
      line-height: 15px;
      padding: 0px 5px;
    }
  }
`

export const SelectStyled = styled.select`
  height: 49px;
  border: 1px solid var(--chakra-colors-primary);
  border-radius: 8px;
  cursor: pointer;
  padding: 9px 14px;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: var(--chakra-colors-primary);
  outline: 0;
  width: 100%;
  transition: all 0.3s;
  background: #fff;

  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: "";

  &.no-borders {
    border: none;
  }

  &.hideValue {
    color: transparent;
  }
`

export const OptionSelect = styled.option`
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: var(--chakra-colors-primary);
  padding: 17px 16px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    color: white;
    background: var(--chakra-colors-primary);
  }
`

export const Arrow = styled.div`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);

  &:focus-within {
    &.isOpen {
      transform: translateY(-50%) rotate(-135deg);
    }
  }
`
